const key = 'BUSINESSTYPE__';

exports.SET_CREATE_EDIT_BUSINESSTYPE = `${key}SET_CREATE_EDIT_BUSINESSTYPE`;
exports.SET_BUSINESSTYPE_ID_TO_EDIT = `${key}SET_BUSINESSTYPE_ID_TO_EDIT`;
